module.exports = __webpack_public_path__ + "media/slot-game/fish-1-7875bf13.svg";